import React, { useState } from 'react'

import { CreateCommentBody } from 'types/GlobalComment'
import { SxProps } from '@mui/material'

import { useCommentActions } from 'redux/actions/Comments'
import { useAnalysisComments } from 'redux/hooks/Comments'
import { useAnalysis } from 'redux/hooks/Analyses'
import { useAnalysisRerun } from 'redux/hooks/AnalysisGenerations'
import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Chip from 'components_new/atoms/Chip'

import ChatInput from 'components_new/molecules/ChatInput'
import CommentThreads from 'components_new/molecules/CommentThreads'
import SectionHeader from 'components_new/molecules/SectionHeader'

interface AnalysisActivityProps {
  id: string
  sx?: SxProps
}

const AnalysisActivity = (props: AnalysisActivityProps) => {
  const { id, sx } = props
  const { t } = useTranslation()

  const {
    analysis
    //  error,
    //  loading
  } = useAnalysis(id)

  const { threads: commentThreads, refetch: refetchComments } =
    useAnalysisComments(analysis)
  const { tryCreateComment } = useCommentActions()
  const { running: rerunning } = useAnalysisRerun(analysis)

  const [comment, setComment] = useState('')

  if (!analysis) {
    return null
  }

  const handleCreateComment = (body: CreateCommentBody) => {
    tryCreateComment(body, refetchComments)
  }

  const handleSubmitComment = () => {
    const value = comment.trim()

    if (!value) return

    handleCreateComment({
      comment: value,
      analysis_id: id,
      segment_value: '0'
    })
    setComment('')
  }

  const commentCount = commentThreads.reduce(
    (total, thread) => total + thread.comments.length,
    0
  )

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, ...sx }}>
      <SectionHeader
        size="medium"
        title={t('comments', 'activity')}
        titleAdornment={<Chip label={commentCount} size="small" />}
      />

      <CommentThreads
        CommentThreadProps={{
          border: false,
          disabledPadding: true,
          displayHeader: false
        }}
        commentThreads={commentThreads}
        analysisId={analysis.id}
        noCommentsBody={t('analyses', 'no_comments_body')}
        onCreateComment={handleCreateComment}
      />

      <ChatInput
        border={true}
        disabled={rerunning}
        multiline={true}
        onChange={setComment}
        onSubmit={handleSubmitComment}
        placeholder={
          rerunning
            ? t('analyses', 'rerun_comment_placeholder')
            : t('analyses', 'write_comment')
        }
        size="small"
        value={comment}
      />
    </Box>
  )
}

export default AnalysisActivity
